import { ErrorEntity } from '../../common/scripts/ErrorHandler/ErrorHandler';
import { String } from '../../common/scripts/Toolkit/Utils/UtilityType';

export enum LogLevel {
    Debug = 'DEBUG',
    Info = 'INFO',
    Warning = 'WARNING',
    Error = 'ERROR',
}

export enum LogTriggerSource {
    Lobby = 'Lobby',
    Game = 'Game',
}

export type LogDataType = {
    Type: string;
    Action: string;
    Level?: LogLevel;
    Source?: LogTriggerSource;
    Detail?: string;
};

export type ErrorReportData = LogDataType;

export type SoundData = {
    effectVolume: number;
    musicVolume: number;
    effectMute: boolean;
    musicMute: boolean;
};

export type LanguageData = {
    language: string;
};

export enum PageName {
    Jackpot = 'jackpot',
}

export type PageStateData = {
    page: PageName;
};

export type PageOpenData = PageStateData;

export type FullscreenData = {
    enabled: boolean;
};

export type OpenGameData = {
    config?: {
        audio?: {
            musicMute?: boolean;
            effectMute?: boolean;
            musicVolume?: number;
            effectVolume?: number;
        };
    };
    performance: {
        defaultFrameRate: number;
        defaultResolution: number;
        loadingFrameRate: number;
        loadingResolution: number;
    };
};

export type LoadingData = {
    progress: number;
};

export enum LobbyMessagePathName {
    Open = 'game.open',
    Progress = 'game.loading.progress',
    Start = 'game.start',
    Close = 'game.close',
    ErrorReport = 'game.error.report',
    Sound = 'sound',
    Language = 'language',
    PageOpen = 'page.open',
    PageClosed = 'page.closed',
    Fullscreen = 'fullscreen',
}

export type LobbyMessage = {
    path: String<LobbyMessagePathName>;
    data: any;
};

export interface ILobbyBaseRequestResponseDataType {
    [PathName: string]: any;
}

export interface ILobbyMessageDataType extends ILobbyBaseRequestResponseDataType {
    [LobbyMessagePathName.Open]: OpenGameData;
    [LobbyMessagePathName.Progress]: LoadingData;
    [LobbyMessagePathName.Start]: void;
    [LobbyMessagePathName.Close]: void;
    [LobbyMessagePathName.ErrorReport]: ErrorEntity;
    [LobbyMessagePathName.Sound]: SoundData;
    [LobbyMessagePathName.Language]: LanguageData;
    [LobbyMessagePathName.PageOpen]: PageStateData;
    [LobbyMessagePathName.PageClosed]: PageStateData;
    [LobbyMessagePathName.Fullscreen]: FullscreenData;
}
